function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "b"
}, /*#__PURE__*/React.createElement("g", {
  id: "c"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 91.84,
  y1: 79.78,
  x2: 2.5,
  y2: 27.9
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 73.08,
  y1: 68.47,
  x2: 90.56,
  y2: 63.48
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 72.68,
  y1: 69.16,
  x2: 77,
  y2: 86.81
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 22.12,
  y1: 38.87,
  x2: 17.79,
  y2: 21.22
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 21.72,
  y1: 39.56,
  x2: 4.24,
  y2: 44.55
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 91.84,
  y1: 28.25,
  x2: 2.5,
  y2: 80.13
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 73.08,
  y1: 39.56,
  x2: 90.56,
  y2: 44.55
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 72.68,
  y1: 38.87,
  x2: 77,
  y2: 21.22
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 22.12,
  y1: 69.16,
  x2: 17.79,
  y2: 86.81
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 21.72,
  y1: 68.47,
  x2: 4.24,
  y2: 63.48
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 47.19,
  y1: 2.5,
  x2: 47.19,
  y2: 105.82
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 47.55,
  y1: 24.41,
  x2: 60.65,
  y2: 11.8
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 46.76,
  y1: 24.41,
  x2: 33.66,
  y2: 11.8
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 47.55,
  y1: 83.34,
  x2: 60.65,
  y2: 95.95
}), /*#__PURE__*/React.createElement("line", {
  className: "d",
  x1: 46.76,
  y1: 83.34,
  x2: 33.66,
  y2: 95.95
})))));

var SvgSnowploughPlain = function SvgSnowploughPlain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 94.34 108.32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnowploughPlain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/snowplough-plain.c8467fd2.svg";
export { ForwardRef as ReactComponent };